import { LeadEntity } from '../../domain/entities/Lead';
import { Lead } from '../../shared/types/Lead';

export const mapApiToEntity = (data: Lead | Record<string, any>): LeadEntity => {
  const raw = data as Record<string, any>;
  const createdAt = raw.createdAt ?? raw.created_at;
  const processedAt = raw.processedAt ?? raw.processed_at;

  return LeadEntity.create({
    id: raw.id,
    chatId: raw.chatId ?? raw.chat_id,
    messageId: raw.messageId ?? raw.message_id,
    senderUsername: raw.senderUsername ?? raw.sender_username,
    messageText: raw.messageText ?? raw.message_text,
    messageLink: raw.messageLink ?? raw.message_link,
    topic: raw.topic ?? null,
    createdAt: new Date(createdAt),
    isConfirmed: raw.isConfirmed ?? raw.is_confirmed,
    isTarget: raw.isTarget ?? raw.is_target,
    processedAt: processedAt ? new Date(processedAt) : undefined,
    senderId: raw.senderId ?? raw.sender_id,
  });
};
